import React from "react";
import { Context } from "@xt/xtbase";
import { fetchPublicUserTags } from "@/utils/userTagGrayRelease";

const { XtContext } = Context;

/**
 * 首页挂载时拉取 /uaapi/user/public/user-tags，写入 XtContext + 模块缓存。
 * 其它页面通过 appState.publicUserTags / isUserTagFeatureEnabled 读取。
 */
export default function PublicUserTagsBootstrap() {
  const [, appDispatch] = React.useContext(XtContext);

  React.useEffect(() => {
    let cancelled = false;

    fetchPublicUserTags()
      .then((allTags) => {
        if (cancelled) return;
        appDispatch({
          payload: {
            publicUserTags: allTags,
            publicUserTagsLoaded: true,
          },
        });
      })
      .catch(() => {
        if (cancelled) return;
        appDispatch({
          payload: {
            publicUserTags: [],
            publicUserTagsLoaded: true,
          },
        });
      });

    return () => {
      cancelled = true;
    };
  }, [appDispatch]);

  return null;
}
